import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	withStyles,
	// Grid,
	ExpansionPanel,
	ExpansionPanelSummary,
	Typography,
	ExpansionPanelDetails,
	Tooltip,
	IconButton,
} from '@material-ui/core'
import { ExpandMore, Info } from '@material-ui/icons'
import classNames from 'classnames'
import styles from './styles'
import { toggleActionTypePanel } from 'actions/tasks'
import { capitalize } from 'lodash'

const ActionTypePanel = ({
	classes,
	toggleActionTypePanel,
	expanded,
	children,
	actionType,
	toolTip,
	snippetsPanelExpanded,
	generalPanelExpanded,
	warning,
}) => {
	const overflow = expanded ? 'visible' : 'hidden'

	return (
		<ExpansionPanel
			// classes={{ expanded: classes.expansionPanelExpanded }}
			style={
				expanded || (generalPanelExpanded && snippetsPanelExpanded)
					? {
							borderRadius: 35,
							overflow,
							marginTop: 12,
							marginBottom: 12,
					  }
					: generalPanelExpanded
					? {
							borderTopLeftRadius: 35,
							borderTopRightRadius: 35,
							borderBottomLeftRadius: 0,
							borderBottomRightRadius: 0,
							overflow,
							marginTop: 12,
					  }
					: snippetsPanelExpanded
					? {
							borderBottomLeftRadius: 35,
							borderBottomRightRadius: 35,
							borderTopLeftRadius: 0,
							borderTopRightRadius: 0,
							overflow,
							marginBottom: 12,
					  }
					: null
			}
			expanded={expanded}
		>
			<ExpansionPanelSummary
				classes={{
					root: classes.expansionPanelSummary,
					expandIcon: classes.expandIcon,
					expanded: classes.expansionPanelSummaryExpanded,
				}}
				onClick={() => toggleActionTypePanel()}
				expandIcon={<ExpandMore />}
			>
				<Typography
					className={
						warning
							? classNames(classes.heading, classes.warning)
							: classes.heading
					}
				>
					{actionType.toUpperCase()}
				</Typography>
				<Tooltip title={warning || capitalize(toolTip)}>
					<IconButton
						disableRipple
						style={{ padding: 0 }}
						className={classNames(
							classes.headingIcon,
							warning ? classes.warning : classes.color,
						)}
					>
						<Info className={classes.icon} />
					</IconButton>
				</Tooltip>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails>{children}</ExpansionPanelDetails>
		</ExpansionPanel>
	)
}

export default connect(
	(state) => ({
		expanded: state.tasks.addOrEdit.actionTypePanelExpanded,
		snippetsPanelExpanded: state.email.snippetsPanelExpanded,
		generalPanelExpanded: state.tasks.addOrEdit.generalPanelExpanded,
	}),
	(dispatch) => bindActionCreators({ toggleActionTypePanel }, dispatch),
)(withStyles(styles)(ActionTypePanel))
